// sources
// https://github.com/knackhq/v3/blob/master/src/lib/Knack.js#L64
// https://github.com/knackhq/app-builder/blob/master/src/field-format-factory.js
// https://github.com/knackhq/Server/blob/master/app/lib/knack.js#L105
export const FieldFormats = {
    address: {
        defaultFormat: {
            input: `address`,
            format: `US`,
            enable_autocomplete: true
        }
    },
    // currently no format options for this type
    auto_increment: {
        defaultFormat: {}
    },
    average: {
        defaultFormat: {
            connection: {
                key: ``
            },
            field: {
                key: ``
            },
            mark_decimal: `none`,
            mark_thousands: `none`,
            post: ``,
            pre: ``,
            precision: `2`,
            rounding: `none`,
            format: ``
        }
    },
    boolean: {
        defaultFormat: {
            default: false,
            format: `yes_no`,
            input: `dropdown`,
            required: false
        }
    },
    // input as empty string implies Searchable Dropdown :facepalm:
    // other input option is "radio"
    connection: {
        defaultFormat: {
            input: ``,
            conn_default: `none`
        }
    },
    // these are the defaults in mongo when you add a new Text Formula field in v2 builder and hit save
    concatenation: {
        defaultFormat: {
            count_field: `Connection`,
            equation: ``,
            equation_type: `numeric`,
            formula_field: `Field`
        }
    },
    count: {
        defaultFormat: {
            connection: ``,
            count_field: `none`,
            mark_thousands: `none`,
            post: ``,
            pre: ``,
            precision: `2`,
            rounding: `none`,
            format: ``
        }
    },
    currency: {
        defaultFormat: {
            format: `$`
        }
    },
    date_time: {
        defaultFormat: {
            date_format: `mm/dd/yyyy`,
            time_format: `Ignore Time`,
            default_type: `current`,
            calendar: false,
            // TODO: which is correct?
            // default_time: `none` <= was in knack.js this.field_formats
            default_time: ``,
            time_type: `current`
        }
    },
    email: {
        defaultFormat: {
            text_format: `url`
        }
    },
    equation: {
        defaultFormat: {
            count_field: `Connection`,
            equation: ``,
            equation_type: `numeric`,
            date_type: `hours`,
            date_result: `number`,
            date_format: `mm/dd/yyyy`,
            time_format: `Ignore Time`,
            formula_field: `Field`,
            mark_decimal: `none`,
            mark_thousands: `none`,
            post: ``,
            pre: ``,
            precision: `2`,
            rounding: `none`,
            format: ``
        }
    },
    file: {
        defaultFormat: {
            secure: false
        }
    },
    image: {
        defaultFormat: {
            source: `upload`,
            thumbs: []
        }
    },
    link: {
        defaultFormat: {
            text_format: `url`,
            target: `_self`
        }
    },
    max: {
        defaultFormat: {
            connection: {
                key: ``
            },
            field: {
                key: ``
            },
            mark_decimal: `none`,
            mark_thousands: `none`,
            post: ``,
            pre: ``,
            precision: `2`,
            rounding: `none`,
            format: ``
        }
    },
    min: {
        defaultFormat: {
            connection: {
                key: ``
            },
            field: {
                key: ``
            },
            mark_decimal: `none`,
            mark_thousands: `none`,
            post: ``,
            pre: ``,
            precision: `2`,
            rounding: `none`,
            format: ``
        }
    },
    multiple_choice: {
        defaultFormat: {
            blank: `Select...`,
            //TODO: which is correct?
            // default: `First Choice` // <= was in knack.js this.field_formats...
            default: `kn-blank`,
            options: [
                `First Choice`,
                `Second Choice`,
                `Third Choice`
            ],
            sorting: `alphabetical`,
            type: `single`
        }
    },
    name: {
        defaultFormat: {
            format: `First Last`
        }
    },
    number: {
        defaultFormat: {
            precision: 0,
            show_commas: false,
            // TODO: which is correct?
            // format: `` // <= was in app-builder field-format-factory.js
            format: `none`,
            // TODO: which is correct?
            // rounding: `none`` // <= was in app-builder field-format-factory.js
            rounding: `default`,
            // TODO: which is correct?
            // mark_decimal: `none` // <= was in app-builder field-format-factory.js
            mark_decimal: `period`,
            mark_thousands: `none`
        }
    },
    // currently no format options for this type
    paragraph_text: {
        defaultFormat: {}
    },
    phone: {
        defaultFormat: {
            extension: false,
            format: `(999) 999-9999`
        }
    },
    rating: {
        defaultFormat: {
            allow_half: false,
            // TODO: which is correct?
            // max: `3` // <= was in app-builder field-format-factory.js
            max: 5,
            method: `stars`,
            min: 1,
            precision: 2
        }
    },
    // currently no format options for this type
    rich_text: {
        defaultFormat: {}
    },
    // currently no format options for this type
    short_text: {
        defaultFormat: {}
    },
    // currently no format options for this type
    signature: {
        defaultFormat: {}
    },
    sum: {
        defaultFormat: {
            connection: {
                key: ``
            },
            field: {
                key: ``
            },
            mark_decimal: `none`,
            mark_thousands: `none`,
            post: ``,
            pre: ``,
            precision: `2`,
            rounding: `none`,
            format: ``
        }
    },
    timer: {
        defaultFormat: {
            // TODO: which is correct?
            // date_format: `mm/dd/yyyy` // <= was in app-builder field-format-factory.js
            date_format: `Ignore Date`,
            limit_range: false,
            method: `start_end`,
            minutes: `1`,
            multi_day: false,
            time_format: `HH:MM am`,
            total_format: `from-to`
        }
    }
};
